import React from 'react';
import { Flex } from 'components/base/layout-components';
import Table from 'components/base/Table';
import Fuse from 'fuse.js';
import { getColor } from 'common/constants/_colors';

const searchOptions = {
  findAllMatches: true,
  threshold: 0.4,
  keys: ['name', 'id', 'email']
};

const filterFn = (data = [], term = '') =>
  term ? new Fuse(data, searchOptions).search(term) : data;

const MergeTable = ({
  data = [],
  initialSearchValue = '',
  prepareData = data => data
}) => (
  <Flex style={{ overflow: 'hidden' }} width='100%' direction='column' pt='big'>
    <Table
      clientSidePagination={true}
      withPagination={data.length > 50}
      data={data}
      localSearchOptions={{
        enabled: true,
        initialSearchValue,
        placeholder: 'Start typing to search for duplicate accounts',
        filterFn,
        prepareData,
        borderProps: { border: 'none' }
      }}
      columns={[
        {
          name: '',
          dataPoint: 'user',
          isSortedCol: true,
          tableCellProps: {
            style: {
              border: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center'
            }
          }
        }
      ]}
      tableComponentProps={{
        style: {
          overflow: 'hidden',
          flexGrow: 1,
          height: '100%',
          width: '99%',
          display: 'flex',
          border: `1px solid ${getColor('botticelli')}`,
          borderRadius: '0.4rem'
        }
      }}
      bodyScrollOptions={{
        enabled: true,
        bodyStyles: {
          width: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
      withTableHead={false}
    />
  </Flex>
);

export default MergeTable;
